import { Theme } from './Theme';
import { isValidTheme } from './ThemeUtils';

let theme: Theme | undefined;
let subscriberCallbacks: (() => void)[] = [];

export function getTheme(): Theme {
  if (!theme) {
    // Compute theme according to the domain
    const defaultTheme = window?.location.host.includes('.pm-international.')
      ? Theme.PM
      : Theme.FitLine;

    setTheme(defaultTheme);
    return defaultTheme;
  }

  return theme;
}

export function setTheme(newTheme: string) {
  if (isValidTheme(newTheme)) {
    theme = newTheme;
    emitChange();
  }
}

export function subscribe(callback: () => void) {
  subscriberCallbacks = [...subscriberCallbacks, callback];
  return () => {
    subscriberCallbacks = subscriberCallbacks.filter(cb => cb !== callback);
  };
}

function emitChange() {
  for (const callback of subscriberCallbacks) {
    callback();
  }
}
